let muzikDataLibrary = [
    {
        id: 1,
        name: "Ek Ladki Ko Dekha Toh Aisa Laga ( Title Track )",
        originalArtist: "Darshan Raval",
        featuring: "Darshan Raval",
        movie: "",
        tags: ["Smule", "Star", "Duet", "Hindi"],
        url: "ZzvRrV0hOCM",
        urlName: "ek-ladki-ko-dekha-toh-aisa-laga"
    },
    {
        id: 2,
        name: "Aaya Na Tu",
        originalArtist: "Arjun Kanango",
        movie: "",
        tags: ["Smule", "Duet", "Hindi"],
        url: "zX1mXLkX4RY",
        urlName: "aaya-na-tu"
    },
    {
        id: 3,
        name: "Tera Yaar Hoon Main",
        originalArtist: "Arijit Singh",
        featuring: "",
        movie: "Sonu Ke Titu Ki Sweety",
        tags: ["Acoustic", "Solo", "Hindi"],
        url: "Zp0mFZTRk4M",
        urlName: "tera-yaar-hoon-main"
    },
    {
        id: 4,
        name: "Phir Bhi Tumko Chahunga",
        originalArtist: "Arijit Singh",
        featuring: "",
        movie: "Half Girlfriend",
        tags: ["Solo", "Hindi", "Event"],
        url: "wRlN_6_kfGA",
        urlName: "phir-bhi-tumko-chahunga"
    },
    {
        id: 5,
        name: "Mere Sapno Ki Rani",
        originalArtist: "Kishor Kumar",
        featuring: "",
        movie: "Aradhana",
        tags: ["Solo", "Hindi", "Event", "Old"],
        url: "VZjL5uX4ggE",
        urlName: "mere-sapno-ki-rani"
    },
    {
        id: 6,
        name: "Bulleya",
        originalArtist: "Amit Mishra",
        featuring: "",
        movie: "Ae Dil Hai Mushkil",
        tags: ["Solo", "Hindi", "Event"],
        url: "7m3PJAvkhlA",
        urlName: "bulleya"
    },
    {
        id: 7,
        name: "Ik Mulaqaat",
        originalArtist: "Ayushmann Khurrana",
        featuring: "",
        tags: ["Smule", "Solo", "Hindi"],
        movie: "Dream Girl",
        url: "9W7Kf1VWgY0",
        urlName: "ik-mulaqaat"
    },
    {
        id: 8,
        name: "Khairiyat",
        originalArtist: "Arijit Singh",
        featuring: "",
        movie: "Chhichhore",
        tags: ["Smule", "Solo", "Hindi"],
        url: "jPdx8hJK8qU",
        urlName: "khairiyat"
    },
    {
        id: 9,
        name: "Ghungroo",
        originalArtist: "Arijit Singh",
        featuring: "",
        movie: "War",
        tags: ["Smule", "Solo", "Hindi"],
        url: "50ytcuvYdcs",
        urlName: "ghungroo"
    },
    {
        id: 10,
        name: "Tujhe Kitna Chahne Lage",
        originalArtist: "Arijit Singh",
        featuring: "",
        movie: "Kabir Singh",
        tags: ["Acoustic", "Solo", "Hindi"],
        url: "3DjiKFEJibA",
        urlName: "tujhe-kitna-chahne-lage"
    },
    {
        id: 11,
        name: "Pariya",
        originalArtist: "Gurnam Bhullar",
        featuring: "",
        movie: "Surkhi Bindi",
        tags: ["Smule", "Solo", "Punjabi"],
        url: "CMbFvs2ZFpY",
        urlName: "pariya"
    },
    {
        id: 12,
        name: "Kalank (Bonus Version)",
        originalArtist: "Arijit Singh",
        featuring: "",
        movie: "Kalank",
        tags: ["Karaoke", "Solo", "Hindi"],
        url: "Tr0gS7T_Idk",
        urlName: "kalank"
    },
    {
        id: 13,
        name: "Sakhiyaan",
        originalArtist: "Maninder Buttar",
        featuring: "Maninder Buttar",
        movie: "",
        tags: ["Smule", "Duet", "Star", "Punjabi"],
        url: "dgWeBQ6_paw",
        urlName: "sakhiyaan"
    },
    {
        id: 14,
        name: "Pyaar Toh Tha",
        originalArtist: "Jubin Nautiyal",
        featuring: "",
        movie: "Bala",
        tags: ["Smule", "Solo", "Hindi"],
        url: "3USgUzeDxGs",
        urlName: "pyaar-toh-tha"
    },

    {
        id: 15,
        name: "Tera Ban Jaunga",
        originalArtist: "Akhil Sachdev",
        featuring: "",
        movie: "Kabir Singh",
        tags: ["Smule", "Duet", "Hindi"],
        url: "77TuZgQQLh4",
        urlName: "tera-ban-jaunga"
    },
    {
        id: 16,
        name: "Naino Ne Baandhi",
        originalArtist: "Yasser Desai",
        featuring: "Yasser Desai",
        movie: "Gold",
        tags: ["Smule", "Star", "Duet", "Hindi"],
        url: "ovLb03z1zIA",
        urlName: "naino-ne-baandhi"
    },
    {
        id: 17,
        name: "Theher Ja",
        originalArtist: "Armaan Malik",
        featuring: "Armaan Malik",
        movie: "October",
        tags: ["Smule", "Star", "Duet", "Hindi"],
        url: "fHBuroVq9d8",
        urlName: "theher-ja"
    },
    {
        id: 18,
        name: "Main Rahoon Ya Na Rahoon",
        originalArtist: "Armaan Malik",
        featuring: "Armaan Malik",
        movie: "",
        tags: ["Star", "Duet", "Hindi", "Event"],
        url: "_XfYL75kht8",
        urlName: "main-rahoon-ya-na-rahoon"
    },
    {
        id: 19,
        name: "Sau Aasmaan",
        originalArtist: "Armaan Malik",
        featuring: "",
        movie: "Baar Baar Dekho",
        tags: ["Smule", "Solo", "Hindi"],
        url: "iKK_gIt373Q",
        urlName: "sau-aasmaan",
        // facebookLink: "https://www.smule.com/recording/armaan-malik-neeti-mohan-sau-aasmaan-baar-baar-dekho/1909969801_3305004200"
    },
    {
        id: 20,
        name: "Duniyaa X Khaab",
        originalArtist: "Akhil Pasreja",
        featuring: "",
        movie: "Luka Chuppi",
        tags: ["Solo", "Hindi", "Punjabi", "Acoustic"],
        url: "YbR3JfM_Vhc",
        urlName: "duniyaa-x-khaab",
        isPinned: false,
        facebookLink: "https://www.facebook.com/NegativeMuzikDreamer/posts/1545430965604398"
    },
    {
        id: 21,
        name: "Chal Ghar Chale",
        originalArtist: "Arijit Singh",
        featuring: "",
        movie: "Malang",
        tags: ["Solo", "Hindi", "Acoustic"],
        url: "pAWYqz_PFyY",
        urlName: "chal-ghar-chale",
        isPinned: false,
        facebookLink: "https://www.facebook.com/NegativeMuzikDreamer/posts/1562936737187154"
    },
    {
        id: 22,
        name: "Phir Na Milen Kabhi",
        originalArtist: "Ankit Tiwari",
        featuring: "",
        movie: "Malang",
        tags: ["Solo", "Hindi", "Acoustic"],
        url: "zeWYNeZ7IJQ",
        urlName: "phir-na-milen-kabhi",
        isPinned: false,
        facebookLink: "https://www.facebook.com/NegativeMuzikDreamer/videos/523425351631790"
    },
    {
        id: 23,
        name: "Mehrama",
        originalArtist: "Darshan Raval",
        featuring: "",
        movie: "Love Aaj Kal",
        tags: ["Solo", "Hindi", "Smule"],
        url: "mTUqg_i4_sU",
        urlName: "mehrama",
        isPinned: false,
        facebookLink: "https://www.facebook.com/NegativeMuzikDreamer/videos/523425351631790"
    },
    {
        id: 24,
        name: "Haaye Ve",
        originalArtist: "Ammy Virk",
        featuring: "",
        movie: "",
        tags: ["Solo", "Punjabi", "Smule"],
        url: "OmGPRhAtdSg",
        urlName: "haaye-ve",
        isPinned: false,
        facebookLink: "https://www.facebook.com/NegativeMuzikDreamer/videos/201893467763037/"
    },
    {
        id: 25,
        name: "Naina Da Kya Kasoor",
        originalArtist: "Amit Trivedi",
        featuring: "Lisa Mishra",
        movie: "AndhaDhun",
        tags: ["Duet", "Hindi", "Smule"],
        url: "Kf4Ev8-tXOI",
        urlName: "naina-da-kya-kasoor",
        isPinned: false,
        facebookLink: "https://www.facebook.com/NegativeMuzikDreamer/videos/248883999613157/"
    },
    {
        id: 26,
        name: "Nazm Nazm",
        originalArtist: "Ayushmann Khurrana",
        featuring: "",
        movie: "Bareilly Ki Barfi ",
        tags: ["Solo", "Hindi", "Smule"],
        url: "pqrGIqE2aoQ",
        urlName: "nazm-nazm",
        isPinned: false,
        facebookLink: "https://www.facebook.com/NegativeMuzikDreamer/videos/2670528269852836/"
    },
    {
        id: 27,
        name: "Raabta ( Kehte Hai Khuda )",
        originalArtist: "Arijit Singh",
        featuring: "",
        movie: "Agent Vinod",
        tags: ["Solo", "Hindi", "Acoustic"],
        url: "XFWmt8dq5D8",
        urlName: "raabta",
        isPinned: false,
        facebookLink: "https://www.facebook.com/328074627340044/videos/243031663456940/"
    },
    {
        id: 28,
        name: "Memories",
        originalArtist: "Maroon 5",
        featuring: "",
        movie: "",
        tags: ["Solo", "English", "Smule"],
        url: "Uii_x9foK_c",
        urlName: "memories",
        isPinned: false,
        facebookLink: "https://www.facebook.com/watch/?v=2966343456774829"
    },
    {
        id: 29,
        name: "Mere Mehboob Qayamat Hogi",
        originalArtist: "Kishor Kumar",
        featuring: "Salim Merchant",
        movie: "Mr.X",
        tags: ["Duet", "Hindi", "Smule", "Star", "Old"],
        url: "G8rHY8mXwTA",
        urlName: "mere-mehboob-qayamat-hogi",
        isPinned: false,
        facebookLink: "https://www.facebook.com/watch/?v=2705066586482509"
    },
    {
        id: 30,
        name: "Jitni Dafa",
        originalArtist: "Yasser Desai",
        featuring: "Yasser Desai",
        movie: "Parmanu",
        tags: ["Duet", "Hindi", "Smule", "Star"],
        url: "x7jFQ7FmOlk",
        urlName: "jitni-dafa",
        isPinned: false,
        facebookLink: "https://www.facebook.com/NegativeMuzikDreamer/videos/722288888506260/"
    },
    {
        id: 31,
        name: "Khulke Jeene Ka",
        originalArtist: "Arijit Singh",
        featuring: "",
        movie: "Dil Bechara",
        tags: ["Solo", "Hindi", "Karaoke"],
        url: "tfOPPXUG1Ic",
        urlName: "khulke-jeene-ka",
        isPinned: false,
        facebookLink: "https://www.facebook.com/NegativeMuzikDreamer/videos/290859515362018/"
    },
    {
        id: 32,
        name: "Zara Zara",
        originalArtist: "Bombay Jayashri",
        featuring: "",
        movie: "Rehnaa Hai Terre Dil Mein",
        tags: ["Solo", "Hindi", "Karaoke", "Unplugged"],
        url: "GfXgfV5CaNo",
        urlName: "zara-zara",
        isPinned: false,
        facebookLink: "https://www.facebook.com/NegativeMuzikDreamer/videos/303672400974066/"
    },
    {
        id: 33,
        name: "Tum Se Hi",
        originalArtist: "Ankit Tiwari",
        featuring: "",
        movie: "Sadak 2",
        tags: ["Solo", "Hindi", "Karaoke"],
        url: "Ja25tmhFgt4",
        urlName: "tum-se-hi",
        isPinned: false,
        facebookLink: "https://www.facebook.com/NegativeMuzikDreamer/videos/661091484525861"
    },
    {
        id: 34,
        name: "Tujhe Kitna Chahein Aur Hum",
        originalArtist: "Jubin Nautiyal",
        featuring: "",
        movie: "Kabir Singh",
        tags: ["Solo", "Hindi", "Karaoke", "Unplugged"],
        url: "SUoAKqXPB1M",
        urlName: "tujhe-kitna-chahein-aur-hum",
        isPinned: false,
        facebookLink: "https://www.facebook.com/NegativeMuzikDreamer/videos/953924218444877/"
    },
    {
        id: 35,
        name: "Mera Pyaar Tera Pyaar",
        originalArtist: "Arijit Singh",
        featuring: "",
        movie: "Jalebi",
        tags: ["Solo", "Hindi", "Acoustic"],
        url: "ZfwVPXomREY",
        urlName: "mera-pyaar-tera-pyaar",
        isPinned: false,
        facebookLink: "https://www.facebook.com/NegativeMuzikDreamer/videos/420288429041752/"
    },
    {
        id: 36,
        name: "Tu Mera Nahi",
        originalArtist: "Amaal Mallik",
        featuring: "",
        movie: "",
        tags: ["Solo", "Hindi", "Karaoke"],
        url: "qEFLP2ZGxKc",
        urlName: "tu-mera-nahi",
        isPinned: false,
        facebookLink: "https://www.facebook.com/NegativeMuzikDreamer/videos/866304800806437/"
    },
    {
        id: 37,
        name: "Ranjha",
        originalArtist: "BPraak, Jasleen",
        featuring: "Amaal Mallik",
        movie: "Shershaah",
        tags: ["Duet", "Hindi", "Smule", "Star"],
        url: "x7Fb0PZOiZs",
        urlName: "ranjha",
        isPinned: false,
        facebookLink: "https://www.facebook.com/NegativeMuzikDreamer/videos/510063390533789/"
    },
    {
        id: 38,
        name: "Shukar Manavaan",
        originalArtist: "Armaan Malik",
        featuring: "",
        movie: "Velle",
        tags: ["Solo", "Hindi", "Karaoke"],
        url: "v4077QZDLXQ",
        urlName: "shukar-manavaan",
        isPinned: false,
        facebookLink: "https://www.facebook.com/NegativeMuzikDreamer/videos/1051513675746665"
    },
    {
        id: 39,
        name: "Saath Ho Tera",
        originalArtist: "Lisa, Amaal, Aastha",
        featuring: "Lisa Mishra",
        movie: "",
        tags: ["Duet", "Hindi", "Smule"],
        url: "LamTRudGJpY",
        urlName: "saath-ho-tera",
        isPinned: true,
        facebookLink: "https://www.facebook.com/NegativeMuzikDreamer/videos/1429621757559597"
    }
]

if (window.location.origin !== 'https://muzikdreamer.com') {
    muzikDataLibrary = muzikDataLibrary.slice(muzikDataLibrary.length - 3, muzikDataLibrary.length);
}

export default muzikDataLibrary;